import { Result, validatedApiCall } from '../api';
import { APIValidationError } from '../../types/api/api';
import { UUID } from '../../types/standard';
import toQueryParams from '../../utils/toQueryParams';
import { UserStates } from '../../types/users/state';

interface MiembroExport {
  content: string;
}
export interface ExportMiembroDTO {
  organizacion?: UUID;
  buscar?: string;
  estado?: UserStates;
}

export const exportMiembro = async (
  data: ExportMiembroDTO,
): Promise<Result<MiembroExport, APIValidationError>> => {
  return validatedApiCall<MiembroExport>(
    `/api/export/miembros?${toQueryParams(data as Record<string, string>)}`,
    {
      method: 'GET',
      auth: true,
    },
  );
};
